import { setupDeliveryBillingMatch } from "./deliveryDetails.js";
import { handleErrorMessage } from "./errorMessage.js";
import { setupSurchargeToggle } from "./surcharge.js";
import { triggerModal } from "./modal.js";

document.addEventListener("DOMContentLoaded", function () {
    setupDeliveryBillingMatch();
    handleErrorMessage();
    setupSurchargeToggle();
    triggerModal();
});
